module.exports = __webpack_public_path__ + "static/media/newspaper.0c89403d.svg";